import { Routes, Route } from 'react-router-dom';
import { ProtectedRouter } from 'infrastructure/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { Router } from 'framework/routing';
import { STAFFING_PROJECT_PATH, STAFFING_PROJECT_ROUTES, StaffingProjectSectionWrapper } from 'domain/shared/project';
import { StaffingTabContent } from './staffing';
import { StaffingProjectTrendsPage } from './trends';
import { StaffingProjectTimelinePage } from './timeline';
import { StaffingProjectContext } from './context/StaffingProjectContext';
import StaffingProjectLayout from './StaffingProjectLayout';
import { GRAPHQL__PROJECT_VIEW__NAVIGATION_SWITCH_TO_STAFFING_VIEW } from 'domain/shared/newProject';

const StaffingProjectRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();
  return (
    <ProtectedRouter basePath={STAFFING_PROJECT_PATH}>
      <Routes>
        <Route
          path={STAFFING_PROJECT_ROUTES.PROJECT}
          element={
            <StaffingProjectContext permissionToCheck={GRAPHQL__PROJECT_VIEW__NAVIGATION_SWITCH_TO_STAFFING_VIEW}>
              <StaffingProjectLayout />
            </StaffingProjectContext>
          }
        >
          <Route index element={<StaffingTabContent />} />
          <Route
            path={STAFFING_PROJECT_ROUTES.TRENDS}
            element={
              <StaffingProjectSectionWrapper>
                <StaffingProjectTrendsPage />
              </StaffingProjectSectionWrapper>
            }
          />
          <Route
            path={STAFFING_PROJECT_ROUTES.TIMELINE}
            element={
              <StaffingProjectSectionWrapper>
                <StaffingProjectTimelinePage />
              </StaffingProjectSectionWrapper>
            }
          />
        </Route>
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

StaffingProjectRouter.getRouterPath = () => `${STAFFING_PROJECT_PATH}/*`;

export default StaffingProjectRouter;
